import type { DataState, DatumOrigin, Outcome } from './types';

/** Rotulos do simulador de regras de credito, sem acento como o resto da tela. */

export const PERMISSAO_SIMULAR = 'credito.parametro.view';

export const resultados: Record<Outcome, string> = {
  elegivel_aprovacao_automatica: 'Elegivel para aprovacao automatica',
  analise_manual: 'Analise manual',
  recusado: 'Recusado',
  pendente_documentacao: 'Pendente de documentacao',
  pendente_consulta: 'Pendente de consulta',
  pendente_aprovacao: 'Pendente de aprovacao',
  segue: 'Segue',
  nao_aplicavel: 'Nao aplicavel',
};

export function rotuloDoResultado(valor: string | undefined | null): string {
  if (!valor) return '';
  return resultados[valor as Outcome] ?? valor;
}

export function tomDoResultado(
  valor: string | undefined,
): 'success' | 'danger' | 'warning' | 'info' | 'neutral' {
  switch (valor) {
    case 'segue':
    case 'elegivel_aprovacao_automatica':
      return 'success';
    case 'recusado':
      return 'danger';
    case 'nao_aplicavel':
      return 'neutral';
    case 'analise_manual':
      return 'warning';
    default:
      return 'info';
  }
}

export const estadosDoDado: Record<DataState, string> = {
  verificado: 'Verificado',
  digitado: 'Digitado',
  ausente: 'Ausente',
  vencido: 'Vencido',
  invalido: 'Invalido',
  indisponivel: 'Indisponivel',
};

/** O que cada coluna da matriz de decisao quer dizer (19, secao 4). */
export const colunasDaMatriz: Record<string, string> = {
  S: 'S: dado presente e regra satisfeita',
  V: 'V: dado presente e regra violada, ou desvio',
  A: 'A: dado ausente apos consulta, ou invalido',
  E: 'E: consulta nao feita, falha ou dado vencido',
  '': 'Sem dado proprio (regra derivada ou de suporte)',
};

export const origens: Record<DatumOrigin, string> = {
  cadastro: 'Cadastro do tomador',
  digitado: 'Digitado',
  documento: 'Documento conferido',
  consulta: 'Consulta ao bureau',
};

export const situacoesDaConsulta = [
  { value: 'encontrado', label: 'Encontrado' },
  { value: 'nao_encontrado', label: 'Nao encontrado' },
  { value: 'indisponivel', label: 'Indisponivel' },
  { value: 'nao_contratado', label: 'Nao contratado' },
  { value: 'nao_aplicavel', label: 'Nao aplicavel' },
  { value: 'erro', label: 'Erro na fonte' },
];

export const produtosDaVigidata = [
  { value: 'analise_credito_cnpj', label: 'Analise de Credito CNPJ (basica)' },
  { value: 'analise_credito_master_cnpj', label: 'Analise de Credito Master CNPJ' },
  { value: 'analise_credito_cpf', label: 'Analise de Credito CPF (basica)' },
  { value: 'analise_credito_master_cpf', label: 'Analise de Credito Master CPF' },
];

export const camposAlterados: Record<string, string> = {
  column: 'coluna',
  calculated: 'calculado',
  effective: 'efeito',
  homologated: 'homologacao',
  shadow: 'sombra',
  recommendation: 'recomendacao',
  reason_id: 'motivo',
  lane: 'esteira',
  message: 'mensagem',
  rule: 'regra',
};

/** A explicacao da diferenca entre o resultado final e o calculado. */
export const EXPLICACAO_FINAL_E_CALCULADO =
  'O resultado final e o que valeria: so decide a regra que esta em regras_homologadas da ' +
  'versao, e a regra fora da lista fica em sombra (PM-01), virando analise manual. O ' +
  'resultado calculado e o que o motor decidiria se todas as regras decidissem. Quando a ' +
  'consulta e de provedor ficticio, a trava SIMULADO acrescenta uma analise manual aos ' +
  'dois, e nenhum chega a elegivel.';

export const AVISO_DA_TELA =
  'Simulacao: o mesmo motor das analises reais, com dados ficticios. Nada e consultado na ' +
  'SeguraCoreCredit e nada e gravado (nenhuma execucao, dado do tomador, consulta ou consumo); fica ' +
  'so o registro de que voce simulou e com qual versao. O resultado nao vale para nenhuma ' +
  'operacao.';
